/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DatalistAnagrafica } from '@models';
import { UtenteService } from '@shared/services/utente.service';

@Component({
    selector: 'app-pages-gestione-utente-profilo',
    templateUrl: './profilo.component.html',
})
export class PagesGestioneUtenteProfiloComponent implements OnInit {

    public datalist: DatalistAnagrafica;
    
    constructor(
        public utenteService: UtenteService,
        private route: ActivatedRoute,
    ) { }

    ngOnInit() {
        this.datalist = this.route.snapshot.data['additionalInformation'].datalist;
    }

}
